import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';

@Component({
  standalone: false,
  selector: 'app-survey-reminder-success',
  templateUrl: './survey-reminder-success.component.html',
  styleUrls: ['./survey-reminder-success.component.scss'],
})
export class SurveyReminderSuccessComponent implements OnInit {

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private pollsandsurveyService: PollsandsurveyService
  ) {
  }

  ngOnInit(): void {
  }

  dismissSuccessModal() {
    this.modal.dismiss();
    location.reload();
  }
}
